module.exports = __webpack_public_path__ + "img/LogoTextBlack.4cb6e45c.svg";